import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { CircularProgress, Dialog, DialogContent, DialogTitle } from '@mui/material'

import { apiZodios } from '~api/apiZodios'
import { Icon, IconButton, Typography } from '~components/internal'
import { type RootState } from '~redux/rootReducer'

import './SystemPromptModal.scss'

interface SystemPromptModalProps {
  isOpen: boolean
  onClose: () => void
  aiInteractionId: string
}

const SystemPromptModal: React.FC<SystemPromptModalProps> = ({
  isOpen,
  onClose,
  aiInteractionId,
}) => {
  const userId = useSelector((state: RootState) => state?.auth.user?.id)
  const [systemPrompt, setSystemPrompt] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    if (!isOpen || !userId) return
    setLoading(true)
    apiZodios
      .ai_superGetAIInteractionSystemPrompt({
        user_id: userId,
        ai_interaction_id: aiInteractionId,
      })
      .then((response) => setSystemPrompt(response.system_prompt ?? null))
      .catch((error) => {
        console.error('Failed to fetch system prompt:', error)
        setSystemPrompt(null)
      })
      .finally(() => setLoading(false))
  }, [isOpen, userId, aiInteractionId])

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth='md' fullWidth>
      <DialogTitle className='system-prompt-modal__title'>
        System Prompt
        <IconButton size='small' onClick={onClose}>
          <Icon name='Close' fontSize='small' />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers className='system-prompt-modal__content'>
        {loading ? (
          <div className='system-prompt-modal__loading'>
            <CircularProgress size={24} />
          </div>
        ) : (
          <Typography variant='body2' className='system-prompt-modal__prompt'>
            {systemPrompt ?? 'No system prompt was recorded for this interaction.'}
          </Typography>
        )}
      </DialogContent>
    </Dialog>
  )
}

export default SystemPromptModal
